import styled from "styled-components";

export const LoaderWrapper = styled.div`
    width: 200px;
    height: auto;
`